import CTA from './cta';

export default CTA;
export { default as CTAAssembly } from './assembly';
